export default {
  authorization (store, payload) {
    store.authorization = payload
  },
  userInfo (store, payload) {
    store.userInfo = payload
  },
  currentFolhaDigit (store, payload) {
    store.currentFolha.currentDigit = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js